// NOAGENDA v2 — shared behavior for all custom sections + Dawn overrides

document.addEventListener('DOMContentLoaded', () => {

  // Nav blur on scroll
  const header = document.querySelector('.header, .header-wrapper');
  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('na-scrolled', window.scrollY > 40);
  };
  document.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Reveal-on-scroll for any element with .na-reveal
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.na-reveal').forEach(el => io.observe(el));

  // Tag each product card's first two images as primary/secondary
  // so the CSS hover-swap rule in noagenda-v2.css has something to target.
  // Give every product card the same fade-up entrance as homepage sections
  document.querySelectorAll('.card-wrapper').forEach(card => {
    card.classList.add('na-reveal');
    io.observe(card);
  });
  document.querySelectorAll('.card__media').forEach(media => {
    const imgs = media.querySelectorAll('img');
    if (imgs[0]) imgs[0].classList.add('na-primary');
    if (imgs[1]) imgs[1].classList.add('na-secondary');
  });
});